// extracted by mini-css-extract-plugin
module.exports = {"content":"i7sbcW-z","tabGroupWrapper":"acygkAlY","CreateNote":"W0CXy69h","createNoteAction":"_3ypgPmPH","createNoteHeader":"_-YIFyS2"};